export let CategoryCardComputed = {
    categoryLink() {
        // product, category,

        if (this.categoryLinkProp === 'product') {
            return {name: 'Products', query: {category: this.category.slug, category_column: 'slug'}}
        }

        if (this.categoryLinkProp === 'category') {
            return {name: 'SingleCategory', params: {slug: this.category.slug}}
        }

        return {name: 'Home',}

    }
}